var map = {
	"./de/common.json": 3617,
	"./de/customP2NDummy.json": 6052,
	"./en/common.json": 5510,
	"./en/customP2NDummy.json": 6172,
	"./es/common.json": 3519,
	"./fr/common.json": 1271,
	"./jp/common.json": 793,
	"./ru/common.json": 5992,
	"./uk/common.json": 8039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4190;